<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="800px">
    <div style="margin: 10px 70px 0 70px">
      <el-form label-position="right" label-width="60px" :model="partsCoe" :rules="rules" ref="partsCoe" :key="isNew"
               style="margin-bottom: 10px; border-bottom: 2px solid lightgrey; display: flex; justify-content: center">
        <remote-form-item :read-only="!isNew" label="部位" prop="partsId" class-name="Parts"
                          class="parts" :remove-set="partsIdSet">
        </remote-form-item>
      </el-form>
      <div style="display: flex">
        <div style="width: 50%; border: 2px solid lightgrey; margin: 0 10px 0 0;">
          <div class="topLabel">钣金</div>
          <div style="margin: 6px 0; padding: 0 0 4px 0; color: black; border-bottom: 1px solid lightgrey">
            <label style="margin-left: 22px">损伤程度</label>
            <label style="margin-left: 36px">系数</label>
            <label style="margin-left: 59px">价格</label>
          </div>
          <el-form label-position="right" label-width="90px" :model="partsCoe.sheetMetalCoe" :rules="rules"
                   ref="partsCoe_sheetMetalCoe">
            <input2-form-item v-for="(damage, index) of sheetMetalDamageDegreeMap" :key="index + 0"
                              :label="damage"
                              :prop="index">
            </input2-form-item>
          </el-form>
        </div>
        <div style="width: 50%; border: 2px solid lightgrey; margin: 0 0 0 10px;">
          <div class="topLabel">喷漆</div>
          <div style="margin: 6px 0; padding: 0 0 4px 0; color: black; border-bottom: 1px solid lightgrey">
            <label style="margin-left: 22px">损伤程度</label>
            <label style="margin-left: 36px">系数</label>
            <label style="margin-left: 59px">价格</label>
          </div>
          <el-form label-position="right" label-width="90px" :model="partsCoe.paintCoe" :rules="rules"
                   ref="partsCoe_paintCoe">
            <input2-form-item v-for="(damage, index) of paintDamageDegreeMap" :key="index + 1"
                              :label="damage"
                              :prop="index">
            </input2-form-item>
          </el-form>
        </div>
      </div>
      <el-form label-position="right" label-width="90px" :model="partsCoe" :rules="rules" ref="partsCoe_rest">
        <div style="display: flex">
          <div style="width: 50%; margin: 0 10px 0 0;">
            <input2-form-item label="拆检" prop="disassemblyCoe" style="margin-top: 10px"></input2-form-item>
            <input2-form-item label="装配" prop="assemblyCoe" style="margin-top: 10px"></input2-form-item>
          </div>
          <div style="width: 50%; margin: 0 0 0 10px;">
            <input2-form-item label="快修" prop="quickCoe" style="margin-top: 10px"></input2-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import Input2FormItem from '@/components/form/Input2FormItem'
  import { isDouble } from '@/utils/validate'

  const coeValidator = {
    validator: (rule, value, callback) => {
      if (!isDouble(value[0]) && !isDouble(value[1])) {
        callback(new Error('请输入合法系数\u0001\u0001请输入合法价格'))
      }
      if (!isDouble(value[0])) {
        callback(new Error('请输入合法系数'))
      } else if (!isDouble(value[1])) {
        callback(new Error('\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001请输入合法价格'))
      } else {
        callback()
      }
    },
    trigger: 'blue'
  }

  export default {
    name: 'EditPartsCoeDialog',
    mixins: [shareDataMixin],
    components: {
      Input2FormItem,
      RemoteFormItem
    },
    props: {
      partsCoe: {
        type: Object,
        required: true
      },
      readOnly: Boolean,
      partsIdSet: {
        type: Set,
        required: true
      }
    },
    data () {
      return {
        rules: {
          partsId: [
            {
              required: true,
              message: '请输选择施工项目',
              trigger: 'change'
            }
          ],
          NEW: [
            coeValidator
          ],
          LIGHT: [
            coeValidator
          ],
          MEDIUM: [
            coeValidator
          ],
          HEAVILY: [
            coeValidator
          ],
          LOCAL: [
            coeValidator
          ],
          HALF: [
            coeValidator
          ],
          FULL: [
            coeValidator
          ],
          disassemblyCoe: [
            coeValidator
          ],
          assemblyCoe: [
            coeValidator
          ],
          quickCoe: [
            coeValidator
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.partsCoe.resetFields()
          this.$refs.partsCoe_sheetMetalCoe.resetFields()
          this.$refs.partsCoe_paintCoe.resetFields()
          this.$refs.partsCoe_rest.resetFields()
        }
      },
      add () {
        this.$refs.partsCoe.validate(valid => {
          if (!valid) return

          this.$store.dispatch('partsCoe/add', this.$_.cloneDeep(this.partsCoe)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      async save () {
        let isValid = true
        await this.$refs.partsCoe.validate(valid => {
          isValid &= valid
        })
        await this.$refs.partsCoe_sheetMetalCoe.validate(valid => {
          isValid &= valid
        })
        await this.$refs.partsCoe_paintCoe.validate(valid => {
          isValid &= valid
        })
        await this.$refs.partsCoe_rest.validate(valid => {
          isValid &= valid
        })

        if (!isValid) return

        this.$store.dispatch('partsCoe/updateOne', this.$_.cloneDeep(this.partsCoe)).then(() => {
          this.hide()
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.partsCoe.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增施工项系数'
        return this.readOnly ? '查看施工项系数' : '编辑施工项系数'
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-form-item {
    margin-bottom: 13px;
  }

  .topLabel {
    color: black;
    text-align: center;
    background-color: lightgrey;
    font-size: 17px;
    height: 28px;
    line-height: 30px;
  }

  /deep/ .parts {
    .el-form-item__label {
      font-size: 15px;
    }

    .value {
      color: blue;
      font-size: 14px;
    }
  }
</style>
